import React, { useState } from "react";
import {
    FaPhoneAlt,
    FaSearch,
    FaBars,
    FaHome,
    FaInfoCircle,
    FaShoppingBag,
    FaArrowCircleRight,
    FaReceipt,
    FaHeart,
} from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import { MdLogout } from "react-icons/md";


import logo from "../assets/Navbar/logo.png";

import dashboard from "../assets/Navbar/dashoboard.png";
import profile from "../assets/Navbar/pro.png";
import cart from "../assets/Navbar/cart.png";
import Logout from "./Logout";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    // const customerType = sessionStorage.getItem("CustomerType");
    // const guestTypes = ["JS_MANAGER", "JS_EMPLOYEE", "TK_MANAGER", "TK_EMPLOYEE"];
    // const isLoggedIn = !guestTypes.includes(customerType);

    const { isLoggedIn, userInfo, loading } = useAuth();
    const customerType = userInfo.CustomerType;

    const navigate = useNavigate();

    if (loading) {
        return null;
    }

    const login = async () => {
        navigate("/login");
    };

    const signup = async () => {
        navigate("/signup");
    };

    const searchitem = async () => {
        navigate("/Search");
    };

    const dashboardPage = async () => {
        navigate("/dashboard");
    };

    const cusDashboardPage = async () => {
        navigate("/cusdashboard");
    };

    const dashboardJapan = async () => {
        navigate("/dashboardjapan");
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleCloseLogout = () => {
        setShowProfile(false);
    };

    const cartpage = async () => {
        navigate("/cart");
    };

    const handleProfile = async () => {
        navigate("/acc");
    };

    // const handleWishlist = async () => {
    //     navigate("/wishlist");
    // };

    const handleImageClick = () => {
        setShowProfile(true);
    };

    return (
        <div className=" w-full h-auto px-2 lg:px-0 bg-[white]">
            <div className="flex gap-2 max-w-screen-xl mx-auto items-center">
                {/* Logo */}
                <div className="text-center border-r  border-[#E5E7EB] p-2 md:pr-6">
                    <button type="" onClick={() => navigate("/home")}>
                        <img className="md:h-10 pt-3 w-10" src={logo} alt="logo" />
                        <p className="text-sm hidden md:block text-[#BB002D] font-bold">store</p>
                    </button>
                </div>

                {/* TOP  */}
                <div className=" w-full py-2 md:p-4 ">
                    <div className="flex justify-between ">
                        <div className="flex">
                            {/* Contact Info */}
                            <div className="hidden md:flex items-center gap-2 text-sm text-[#8B0000] font-bold ">
                                {/* <FaPhoneAlt className="text-[#4B5563]" />
                                +91 88484 83211 */}
                            </div>
                        </div>
                        <div className="flex pb-2">
                            <div className="flex items-center gap-4 text-sm">
                                <div className="hidden lg:flex gap-4 font-medium">
                                    <Link
                                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                        className="text-base font-[600] font-display2"
                                        to="/home"
                                    >
                                        Home
                                    </Link>
                                    <Link
                                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                        className="text-base font-[600] font-display2"
                                        to="/categories"
                                    >
                                        Shop
                                    </Link>
                                    <Link
                                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                        className="text-base font-[600] font-display2"
                                        to="/about"
                                    >
                                        About Us
                                    </Link>
                                    <Link
                                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                        className="text-base font-[600] font-display2"
                                        to="/contact"
                                    >
                                        Contact Us
                                    </Link>
                                    {(customerType === "DEALER" || customerType === "CUSTOMER") && (
                                        <Link
                                            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                                            className="text-base font-[600] font-display2"
                                            to="/receipt"
                                        >
                                            Receipt
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* divider  */}
                    <hr className="border-t hidden md:block border-[#E5E7EB]" />

                    {/* BOTTOM  */}
                    <div className="flex justify-between md:pt-2">
                        <div className="flex">
                            {/* Menu Button */}

                            <div className="flex h-8">
                                <button
                                    className=" lg:hidden bg-[#8B0000] text-[white] px-2 mr-2 rounded-md flex items-center gap-2 text-sm font-semibold"
                                    onClick={toggleMenu}
                                >
                                    {isMenuOpen ? <IoClose /> : <FaBars className="" />}
                                </button>
                            </div>
                        </div>

                        {/* Search  */}
                        <div className="flex w-[50%] items-center gap-2">
                            {/* Mobile Search Input */}
                            <div className="bg-[#F3F4F6]  items-center w-full rounded-full px-3 py-2 text-sm">
                                <div className="flex items-center">
                                    <FaSearch className="text-[#BB002D] size-5 mr-2" onClick={searchitem} />
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="bg-[#F3F4F6] outline-none w-full"
                                        onClick={searchitem}
                                    />
                                </div>
                            </div>
                            <div className="flex">
                                <FaArrowCircleRight className="size-6 text-[#BB002D] cursor-pointer" />
                            </div>

                            {/* Desktop Search Icon */}
                            {/* <div className=" sm:hidden w-[20%]">
                                <img src={search} alt="search" style={{ cursor: "pointer" }} onClick={searchitem} />
                            </div> */}
                        </div>

                        {/* Buttons  */}

                        {isLoggedIn ? (
                            <div className="flex items-center md:gap-4">
                                {/* Dashboard Icon */}
                                {customerType !== "CUSTOMER" && (
                                    <div className="w-full">
                                        <img
                                            src={dashboard}
                                            alt="dashboard"
                                            onClick={dashboardPage}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </div>
                                )}
                                {customerType === "CUSTOMER" && (
                                    <div className="w-[50%]">
                                        <img
                                            src={dashboard}
                                            alt="dashboard"
                                            onClick={cusDashboardPage}
                                            style={{ cursor: "pointer" }}
                                        />
                                    </div>
                                )}
                                {customerType !== "CUSTOMER" && customerType !== "AGENT" && customerType !== "DEALER" && (
                                    <div className="lg:w-[15%] w-20% ">
                                        <img
                                            style={{ cursor: "pointer" }}
                                            src={dashboard}
                                            alt="dashboard"
                                            onClick={dashboardJapan}
                                        />
                                    </div>
                                )}

                                {/* {customerType === "CUSTOMER" && (
                                    <div className="md:flex cursor-pointer hidden">
                                        <button onClick={handleWishlist}>
                                            <FaHeart className="size-5" />
                                        </button>
                                    </div>
                                )} */}

                                <div className="flex w-full">
                                    {/* Cart Icon (hidden for AGENT) */}
                                    {customerType !== "AGENT" && (
                                        <div className="flex  w-full">
                                            <img style={{ cursor: "pointer" }} src={cart} alt="cart" onClick={cartpage} />
                                        </div>
                                    )}

                                    {/* Profile Icon  */}
                                    <div className="flex w-full">
                                        <img
                                            style={{ cursor: "pointer" }}
                                            src={profile}
                                            alt="profile"
                                            onClick={handleProfile}
                                        />
                                    </div>
                                </div>

                                {/* Logout Button */}
                                <div>
                                    <button
                                        onClick={handleImageClick}
                                        className="border border-[#8B0000] text-[#8B0000] px-3 py-1 rounded-md font-semibold hidden md:block"
                                    >
                                        Log&nbsp;Out
                                    </button>
                                    <button
                                        onClick={handleImageClick}
                                        className=" text-[#8B0000] text-[20px] py-1 rounded-md font-bold md:hidden"
                                    >
                                        <MdLogout />
                                    </button>
                                    {showProfile && <Logout onCancel={handleCloseLogout} />}
                                </div>
                            </div>
                        ) : (
                            <div className="flex gap-2">
                                <button
                                    onClick={login}
                                    className="border border-[#8B0000] text-[#8B0000] px-3 py-1 rounded-md font-semibold "
                                >
                                    Log&nbsp;In
                                </button>
                                <button
                                    onClick={signup}
                                    className="border border-[#8B0000] bg-[#8B0000] px-3 py-1 rounded-md font-semibold hidden md:block text-[white]"
                                >
                                    Register
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* <div className="flex flex-row  w-full  md:h-[85px]"> */}
            {/* <div className="flex flex-row  w-full ">
                <div className="w-[30%] h-[100%]">
                    <div className="flex flex-row justify-end items-center w-[100%] lg:w-[80%] h-[100%] gap-[5%] ">
                        {customerType !== "CUSTOMER" && customerType !== "AGENT" && customerType !== "DEALER" && (
                            <div className="lg:w-[15%] w-20% ">
                                <img
                                    style={{ cursor: "pointer" }}
                                    src={dashboard}
                                    alt="dashboard"
                                    onClick={dashboardJapan}
                                />
                            </div>
                        )}
                    </div>
                    <div className=" w-[20%] h-[100%] hidden lg:block"></div>
                </div>
            </div> */}
            {isMenuOpen && (
                <div className="lg:hidden absolute bg-[#f3f4f6ea] w-full p-4 z-40">
                    <Link
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className=" flex items-center gap-2 p-2 text-[16px] font-[600] font-[Roboto]"
                        to="/home"
                    >
                        <FaHome className="text-[#8b0000]" /> Home
                    </Link>
                    <Link
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className=" flex items-center gap-2 p-2 text-[16px] font-[600] font-[Roboto]"
                        to="/categories"
                    >
                        <FaShoppingBag className="text-[#8b0000]" /> Shop
                    </Link>
                    <Link
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className=" flex items-center gap-2 p-2 text-[16px] font-[600] font-[Roboto]"
                        to="/about"
                    >
                        <FaInfoCircle className="text-[#8b0000]" /> About Us
                    </Link>
                    <Link
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className=" flex items-center gap-2 p-2 text-[16px] font-[600] font-[Roboto]"
                        to="/contact"
                    >
                        <FaPhoneAlt className="text-[#8b0000]" /> Contact Us
                    </Link>
                    {(customerType === "DEALER" || customerType === "CUSTOMER") && (
                        <Link
                            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                            className=" flex items-center gap-2 p-2 text-[16px] font-[600] font-[Roboto]"
                            to="/receipt"
                        >
                            <FaReceipt className="text-[#8b0000]" /> Receipt
                        </Link>
                    )}
                </div>
            )}
        </div>
    );
}

export default Navbar;
